{
  "settings_title": "Recognitions",
  "settings_description": "Awards and achievements",
  "permission_type_view": "View",
  "permission_type_view_and_gift": "View and give",
  "column_recognition": "Recognition",
  "column_given_by": "Given by",
  "revoked_by": "Revoked by {name}",
  "revoke": "Revoke",
  "revoke_question": "Revoke recognition",
  "revoke_confirm": "Are you sure you want to revoke {title} from {name}?",
  "history_empty_title": "No recognitions yet",
  "history_empty_description": "Awarded recognitions will appear here.",
  "history_search_placeholder": "Search by employee",
  "filter_recognitions": "Recognitions",
  "filter_recipient": "Recipient",
  "filter_awarded_by": "Given by",
  "recognitions_count": "{count, plural, one {# recognition} other {# recognitions}}",
  "category_create_title": "New category",
  "category_create_caption": "of recognitions",
  "category_edit_title": "Edit category",
  "category_delete": "Delete category",
  "category_delete_named": "Delete category {title}",
  "category_delete_confirm": "Are you sure you want to delete category {title}?",
  "category_delete_unavailable": "Cannot delete category",
  "category_delete_contains": "This category contains recognitions",
  "gift_modal_title": "Gift recognition",
  "gift_recipient_label": "Recipient",
  "gift_choose_recipient": "Choose recipient...",
  "gift_recipient_required": "Choose a recipient",
  "gift_send_to": "Send to",
  "gift_multiple_recipients": "multiple recipients",
  "gift_comment_label": "Comment",
  "gift_comment_placeholder": "Add optional comment...",
  "gift_create_recipient_group": "Create recipient group",
  "gift_return_to": "Return to",
  "gift_single_recipient": "single recipient",
  "gift_recipients_count": "{count, plural, one {# person will be recognized} other {# people will be recognized}}",
  "gift_recipients_caption": "will receive the award",
  "gift_send": "Send recognition",
  "gift_success": "Sent!",
  "gift_recipients_gifted": "{count, plural, one {# person received your recognition.} other {# people received your recognition.}}",
  "gift_gifted_to": "{name} received your recognition.",
  "gift_recognition_title": "Gift recognition to...",
  "gift_recognition_caption": "One or multiple employees",
  "recognition_delete": "Delete...",
  "recognition_delete_named": "Delete recognition {title}",
  "recognition_delete_confirm": "Are you sure you want to delete recognition {title}?",
  "recognition_delete_unavailable": "Cannot delete recognition",
  "recognition_delete_granted": "This recognition has already been awarded",
  "column_created_by": "Created by",
  "column_awarded_to": "Awarded to",
  "granted_count": "{count, plural, one {# employee} other {# employees}}",
  "search_placeholder": "Recognition title",
  "recognition_create_title": "New recognition",
  "recognition_edit_title": "Edit recognition",
  "profile_title": "Recognitions",
  "by_author": "By {name}",
  "profile_count": "{count, plural, one {# recognition from colleagues and managers} other {# recognitions from colleagues and managers}}",
  "view_title": "View recognition",
  "actions": "Actions",
  "awarded_by": "Awarded by",
  "comment": "Comment",
  "menu_edit": "Edit recognition",
  "menu_delete": "Delete recognition",
  "delete_confirm": "Are you sure you want to delete recognition {title}?",
  "edit_title": "Edit recognition",
  "field_awarded_at": "Award date",
  "profile_gift": "Gift recognition",
  "gift_award": "Gift award",
  "view_all": "View all recognitions",
  "feature_title": "Recognitions",
  "feature_description": "Let employees celebrate each other's achievements with badges.",
  "gift_search_placeholder": "Recognition title",
  "field_category": "Category",
  "field_category_placeholder": "Choose category...",
  "field_badge": "Badge",
  "art_required": "Upload a badge image",
  "gift_rules_title": "Who can gift",
  "gift_rules_caption": "Only employees matching these rules can gift awards from this category. Leave empty to disable gifting.",
  "gift_disabled_tag": "Awarding off",
  "gift_disabled_hint": "This category has no rules, so nobody can award its recognitions. Set rules in the category settings to allow awarding.",
  "gift_no_available_title": "No awards to give",
  "profile_empty_title": "No recognitions yet",
  "profile_empty_description": "This employee hasn't received any recognitions yet.",
  "category_recognitions_empty_title": "No recognitions yet",
  "category_recognitions_empty_description": "Add a recognition to this category.",
  "give_first_recognition": "Give first recognition",
  "give_recognition": "Give recognition",
  "view_recognitions": "View {count, plural, one {# recognition} other {# recognitions}}"
}
